module.exports = __webpack_public_path__ + "static/media/ehealthpro_faq-banner-bg.0b88e07f.jpg";